export default "__VITE_ASSET___i3tccVI__"